import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtocol = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 16,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 24,
			r: 6,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 8V18M24 30V40M8 24H18M30 24H40",
			stroke: "currentColor",
			strokeWidth: 1,
			opacity: .35
		})
	]
});
export default SvgProtocol;
